import { useLazyQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { Queries } from '@shared/api';

type GetWorkflowTemplateFunction = (
  id: string,
) => Promise<MBAPI.WorkflowTemplate | null | undefined>;

export function useGetWorkflowTemplateLazyQuery(): GetWorkflowTemplateFunction {
  const [getWorkflowTemplate] = useLazyQuery<
    MBAPI.GetWorkflowTemplateWithCardDefinitionQuery,
    MBAPI.GetWorkflowTemplateWithCardDefinitionQueryVariables
  >(Queries.workflow.getWorkflowTemplateWithCardDefinition);
  return useCallback<GetWorkflowTemplateFunction>(
    async (id: string) => {
      if (!isNil(id)) {
        const variables = { id };
        const result = await getWorkflowTemplate({ variables });
        return result.data?.getWorkflowTemplate;
      }
    },
    [getWorkflowTemplate],
  );
}
